import curd from '../curd'

const BASE_PATH = '/quality/reconstruction'

export default curd(BASE_PATH, {
  getQualityData: query => ({
    url: `${BASE_PATH}/data`,
    method: 'POST',
    data: query
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/QualityRestructure.js